import React, { useEffect, useState } from "react";
import {
  Container,
  DateRangeWrapper,
  Wrapper,
  Row,
  DateInput,
  DateTitle,
  SaveButton,
} from "./styled";
import { DateRange } from "react-date-range";
import { pt } from "date-fns/locale";
import Button from "../../ReUsableComponents/Button";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "../../../../../Redux/Slices/alertSlice";
import { startDueDatesUpdate } from "../../../../../Services/cardService";

const DatePopover = (props) => {
  const dispatch = useDispatch();
  const card = useSelector((state) => state.card);

  const [state, setState] = useState([
    {
      startDate: card.date.startDate
        ? moment(card.date.startDate).add(3, "hours").toDate()
        : new Date(),
      endDate: card.date.dueDate
        ? moment(card.date.dueDate).add(3, "hours").toDate()
        : new Date(),
      key: "selection",
    },
  ]);

  const [startDate, setStartDate] = useState(
    moment(state[0].startDate).format("YYYY-MM-DD")
  );
  const [dueDate, setDueDate] = useState(
    moment(state[0].endDate).format("YYYY-MM-DD")
  );

  useEffect(() => {
    setStartDate(moment(state[0].startDate).format("YYYY-MM-DD"));
    setDueDate(moment(state[0].endDate).format("YYYY-MM-DD"));
  }, [state]);

  const handleBlur = () => {
    const date1 = moment(startDate).toDate();
    const date2 = moment(dueDate).toDate();
    if (date1 > date2) {
      dispatch(
        openAlert({
          message:
            "A data de vencimento não pode ser menor que a data de início!",
          severity: "error",
        })
      );
      setState([
        {
          startDate: moment(startDate).toDate(),
          endDate: moment(dueDate).toDate(),
          key: "selection",
        },
      ]);
      return;
    }
    setState([
      {
        startDate: date1,
        endDate: date2,
        key: "selection",
      },
    ]);
  };

  const handleSaveClick = async () => {
    props.closeCallback();
    await startDueDatesUpdate(
      card.cardId,
      card.listId,
      card.boardId,
      startDate,
      dueDate,
      null,
      dispatch
    );
  };

  const handleRemoveClick = async () => {
    props.closeCallback();
    await startDueDatesUpdate(
      card.cardId,
      card.listId,
      card.boardId,
      null,
      null,
      null,
      dispatch
    );
  };

  return (
    <Container>
      <DateRangeWrapper>
        <DateRange
          editableDateInputs={false}
          onChange={(item) => setState([item.selection])}
          moveRangeOnFirstSelection={false}
          ranges={state}
          locale={pt}
        />
      </DateRangeWrapper>
      <Wrapper>
        <DateTitle>Data Inicial</DateTitle>
        <Row>
          <DateInput value={startDate} onBlur={handleBlur} type="date" />
        </Row>
        <DateTitle>Data de vencimento</DateTitle>
        <Row>
          <DateInput value={dueDate} onBlur={handleBlur} type="date" />
        </Row>
        <SaveButton onClick={handleSaveClick}>Salvar</SaveButton>
        <Button clickCallback={handleRemoveClick} title="Remover" />
      </Wrapper>
    </Container>
  );
};

export default DatePopover;
